<template>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar color-sidebar-light-white"  :class="!showSidebar ? 'collapse-sidebar' : ''">
    
    <div class="text-center mb-3 box-profile sidebar-profile" style="background: transparent;" >
      <div class="row" style="display:none;">
          <div class="col-sm-3">
             <img :src="profile.avatar" width="35"   />
           </div> 
          <div class="col-sm-9 text-left"> 
             <b> {{ profile.fid }} </b><br />
             <small>{{ profile.jabatan }}</small><br />
          </div>
        </div>     
    
    </div> 
    <!-- Sidebar scroll-->
    <perfect-scrollbar>
    <div class="scroll-sidebar" :class="!showSidebar ? 'mini-sidebar' : ''">
      <!-- Sidebar navigation-->
     
            <nav class="sidebar-nav">
            <ul id="sidebarnav">
                <template v-for="menu in menu_utama" >
                    <li v-if="menu.type =='header'" class="nav-small-cap"> <span>{{ menu.title}} </span></li>
                    <li v-else> 
                        <template v-if="menu.sub.length > 0"> 

                            <a  @click="toggle( menu )" :class="{'has-arrow waves-effect waves-dark' : menu.sub.length > 0 ,  '': menu.color }" aria-expanded="false"> 
                               <icon :name="menu.icon" class="md-size-1x mr-2  w-25"   />
                              <span class="hide-menu"> {{ menu.title }}  <span v-if="menu.module =='kinerja'" class="badge badge-danger" style="float: right">New</span>  </span> 
                            </a> 
                            <ul v-if="menu.sub.length > 0 " :aria-expanded="false" :class="menu.collapse" >
                                <template v-for="child in menu.sub" >
                                <li>                         
                                    <a :href="'#/'+child.module">
                                        {{ child.title }}

                                    </a>
                                </li>
                                </template>
                            </ul>
                        </template>    
                        <template v-else>
                            <a  :href="'#/'+menu.module" :class="menu.color"> 
                               <icon :name="menu.icon" class="md-size-1x mr-2  w-25"  />
                              <span class="hide-menu"> {{ menu.title }} </span> 
                            </a>
                            
                        </template>
                        
                    </li>
                </template>
              </ul>         
            </nav>
     
    <!-- End Sidebar scroll-->  
      <!-- End Sidebar navigation -->

       
      <!-- End Sidebar navigation -->
    </div>
     </perfect-scrollbar>
    <!-- End Sidebar scroll-->
  </aside>
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
</template>

<script>
import { mapState, mapMutations } from "vuex";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
        VuePerfectScrollbar
    },
  computed: {
    ...mapState({
      showSidebar: state => state.showSidebar,
    //  menuItem: state => state.menuItem
    })
  },
  data() {
    return {
        menuItem : [] ,
        profile:[] ,
        is_fasilitator : false ,
        menu_utama : [
            { type : 'header' , title : 'Headline Utama' , module : '' , icon : ''} ,
            { type : 'link' , title : 'Headline & Info Grapis' , module : 'dashboard' , icon : 'chart-bar' , color: 'green' , collapse : 'collapse' , sub : [
                { type : 'link' , title : ' Dashboard Utama' , module : 'dashboard' , icon : 'pie-chart' },
                { type : 'link' , title : ' Kompetensi By Jabatan' , module : 'stat_kompetensi' , icon : 'sitemap' },
                { type : 'link' , title : ' Jabatan Vs Pendidikan' , module : 'plt' , icon : 'user' }
            ]} ,
            { type : 'link' , title : 'Pemetaan Talenta 9 Box' , module : 'box' , icon : 'table' , collapse : 'collapse' , sub : []},
            { type : 'link' , title : 'Rekomendasi Jabatan' , module : 'rekomendasi' , icon : 'user' , collapse : 'collapse' , sub : []},
            { type : 'link' , title : 'Human Capital Dev (HCDP)' , module : 'human_capital' , icon : 'database' , collapse : 'collapse' , sub : []},
            { type : 'link' , title : 'Peta Jabatan & Suksesor' , module : 'formasi' , icon : 'document-text' , collapse : 'collapse' , sub : []}, 

            { type : 'link' , title : 'EWS -BUP ' , module : 'kosong' , icon : 'duplicate' , color: '5' ,  collapse : 'collapse',sub:[]} ,
            { type : 'header' , title : 'Suksesi' , module : '' , icon : ''} ,
            { type : 'link' , title : 'Simulasi Rencana Suksesi' , module : 'simulasi' , icon : 'adjustments' , color: 'light-5' , collapse : 'collapse' , sub : []} ,
            { type : 'link' , title : 'SitePlan  ( Mapping ) ' , module : 'skema' , icon : 'share' , color: '5' , collapse : 'collapse' ,sub : [] } ,
            { type : 'link' , title : 'Monitoring Suksesor' , module : 'suksesor' , icon : 'user' , color: '5' , collapse : 'collapse' ,sub : []} ,
            { type : 'header' , title : 'BASELINE DATA' , module : '' , icon : ''} ,

            { type : 'link' , title : 'Skor Talenta Pegawai' , module : 'skoring' , icon : 'star' , color: '5' ,  collapse : 'collapse' , sub : []} ,
            { type : 'link' , title : 'Data Assessmen ' , module : 'assessment' , icon : 'clock' , color: '5' ,  collapse : 'collapse' , sub : []} ,
            { type : 'link' , title : 'Pemetaan Kompetensi' , module : 'kompetensi' , icon : 'globe' , color: '5' ,  collapse : 'collapse' , sub : []} ,

            { type : 'header' , title : 'Utilitas' , module : '' , icon : ''} , 
            { type : 'link' , title : 'Tim Penilai' , module : 'penilai' , icon : 'user' , color: '5' ,  collapse : 'collapse' , sub : [] } ,
            { type : 'link' , title : 'Rekonsiliasi Data' , module : 'rekonsiliasi' , icon : 'cog' ,color: '5' ,  collapse : 'collapse' , sub : []} ,
            
        ],
        sidemenu : []
    }
  },
  mounted() {
    this.fetchData()
     this.profile = JSON.parse(localStorage.getItem('profile')) 
    this.sidemenu = this.menu_utama
     if( this.profile.is_fasilitator == true) {
        this.is_fasilitator = true 
     }
  },
  methods: {
    ...mapMutations({
     // toggleDropdown: "toggleDropdown"
    }),
     toggleDropdown(index) {
      this.menuItem[index].collapsed = !this.menuItem[index].collapsed;
    },
    toggle( currentMenu ) {
        
     // if (currentMenu.type === 'link') {
         console.log( currentMenu.module )
        this.sidemenu.forEach(element => {
          
          if (element.module == currentMenu.module) {
            console.log( currentMenu.module )

             currentMenu.collapse =  ( currentMenu.collapse  == 'collapse' ? '' : 'collapse' );
          }  else {
           // element.collapse = '';
          }
        });
      //}
    },
    scrollHandle(evt) {
      console.log(evt)
    },
    switchMode() {
        if(this.profile.template =='public') {
            this.profile.template ='admin'
        } else {
          this.profile.template ='public'
        }
        localStorage.setItem('profile', JSON.stringify(this.profile))
        this.$router.push('/diklat')
        window.location.reload()
        
    },
    fetchData() {

       
    }
  }
};
</script>

<style scoped>
.collapse-sidebar {
  width: 70px;
}
.collapse-sidebar #sidebarnav > li > a.has-arrow:after {
  display: none;
}
.svg-inline--fa {
  font-size: 18px;
}
.left-sidebar svg  {
    padding: 2px;
    
}
.left-sidebar a.red svg {
     
      color: #ff0000;
} 
.left-sidebar a.orange svg {
     
      color: #ff9900;
} 
.left-sidebar a.purple svg {
   
      color: #6A1B9A;
} 
.left-sidebar a.blue svg {
    
      color: #398bf7;
} 
.left-sidebar a.light-green svg {
     
      color: #558B2F;
} 
.left-sidebar a.pink svg {
     
      color: #FF80C0;
} 

.ps {
  height:calc(100vh - 127px) ;
}
.w-20 {
  width: 20px;
}
.w-25 {
  width: 23px !important;
}
.w-30 {
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SidebarUser.vue